import { Category as CategoryModel } from '../../../models/backend-api';
import { WidgetPhrases } from '../../../models/widget-model';

export const getSpecialShowMoreCategoryLabel = (phrases: WidgetPhrases) => phrases.show_more_categories_button;
export const SHOW_MORE_CATEGORY_ORDER = 99999;
export const isShowMoreSpecialCategory = (category: CategoryModel, phrases: WidgetPhrases) =>
    (category.label === getSpecialShowMoreCategoryLabel(phrases)) && (category.order === SHOW_MORE_CATEGORY_ORDER);
